import { CreateIntegrationStepPayload } from '@autonomous-testing/sdk';
import { Locator, Page } from '@playwright/test';

export interface TrackElementOptions extends Omit<CreateIntegrationStepPayload, 'imageBase64'> {
  locator: Locator;
}

export interface TrackFullPageOptions extends Omit<CreateIntegrationStepPayload, 'imageBase64'> {
  page: Page;
}

export interface TrackImageOptions extends CreateIntegrationStepPayload {}

export interface TrackViewportOptions extends Omit<CreateIntegrationStepPayload, 'imageBase64'> {
  page: Page;
}
